import { useEditarConfigDeEnvelopeContext } from "../..";
import OrSpinner from "../../../../../../Components/Utils/OrSpinner";
import { InserirConfigEnvelopeDestinatarioController } from "../../../../../../Controllers/Geral/ConfigEnvelope/ConfigEnvelopeDestinatario/ConfigEnvelopeDestinatarioControllers";
import DestinatarioASerInseridoNaConfiguracao from "../DestinatarioASerInseridoNaConfiguracao";

interface ITabelaInserirDestinatarioUsuarioProps {}

export default function TabelaInserirDestinatarioUsuario(
    props: ITabelaInserirDestinatarioUsuarioProps
) {
    const {
        idConfigEnvelope,
        destinatariosConfigEnvelope: { lst: lstDestinatariosConfigEnvelope },
        usuariosSpeDoProduto: { lst: lstUsuarioSpe, loading },
    } = useEditarConfigDeEnvelopeContext();

    async function VincularUsuarioSpeAConfiguracao(idUsuarioSpe: number) {
        await InserirConfigEnvelopeDestinatarioController({
            ID_ENVELOPE_DOCUSIGN_CONFIG: idConfigEnvelope,
            ID_USUARIO: idUsuarioSpe,
        });
    }

    return (
        <OrSpinner
            loading={loading}
            wrapperLoadingClasses="w-100 d-flex justify-content-center"
            loadingColor="primary"
        >
            {lstUsuarioSpe?.map((usuarioSpe) => (
                <DestinatarioASerInseridoNaConfiguracao
                    descricao={usuarioSpe.DS_NOME}
                    key={usuarioSpe.ID_USUARIO}
                    vincular={async () =>
                        VincularUsuarioSpeAConfiguracao(usuarioSpe.ID_USUARIO)
                    }
                    idVinculado={
                        lstDestinatariosConfigEnvelope.find(
                            (d) => d.ID_USUARIO === usuarioSpe.ID_USUARIO
                        )?.ID_ENVELOPE_DOCUSIGN_CONFIG_DESTINATARIO
                    }
                />
            ))}
        </OrSpinner>
    );
}
